import { Box } from '@mui/material';
import { ThumbnailContainer } from '@/components/ThumbnailPreview/ThumbnailPreview';

export const AssetThumbnailGrid = ({
  assetIds,
  tenantId,
  maxDisplay = 8,
  thumbnailSize = 58,
}: {
  assetIds: string[];
  tenantId: string;
  maxDisplay?: number;
  thumbnailSize?: number;
}) => {
  const displayedAssets = assetIds.slice(0, maxDisplay);
  const remainingCount = assetIds.length - maxDisplay;

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {displayedAssets.map(assetId => (
        <ThumbnailContainer key={assetId} asset={{ id: assetId, tenantId }} size={thumbnailSize} />
      ))}
      {remainingCount > 0 && (
        <Box
          sx={{
            width: thumbnailSize,
            height: thumbnailSize,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'action.selected',
            borderRadius: '4px',
            fontSize: thumbnailSize > 50 ? '13px' : '12px',
            fontWeight: 600,
            color: 'text.secondary',
          }}
        >
          +{remainingCount}
        </Box>
      )}
    </Box>
  );
};
